import React from 'react';
import PropTypes from 'prop-types';

import { lang as l10nLang } from '@ott/l10n';

import formatDate from './helpers/formatDate';

class FormattedDate extends React.PureComponent {
  static propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    isShortMonth: PropTypes.bool,
    showMonth: PropTypes.bool,
    showYear: PropTypes.bool,
    lang: PropTypes.string,
    showWeekday: PropTypes.bool,
  };

  static defaultProps = {
    isShortMonth: false,
    showMonth: true,
    showYear: false,
    lang: l10nLang,
    showWeekday: false,
  };

  constructor(props, ctx) {
    super(props, ctx);
  }

  render() {
    const {
      date,
      showYear,
      showMonth,
      isShortMonth,
      lang,
      className,
      style,
      showWeekday,
      dataLocator,
    } = this.props;

    return (
      <span className={className} style={style} data-locator={dataLocator}>
        {formatDate({
          date,
          showYear,
          showMonth,
          isShortMonth,
          lang,
          showWeekday,
        })}
      </span>
    );
  }
}

export default FormattedDate;

export { formatDate };
